import { useAtom } from 'jotai';

import { computeTier, hasCreditsLeft } from '@flintmint/core-shared/utils';
import { Banner } from '@flintmint/web-shared/components/banner';

import { isPastDue } from '@/features/billing/billing-state';
import { getEnergyView } from '@/features/llm-chat/energy/energy-view';
import { energyActionLabels, useEnergyAction } from '@/features/llm-chat/energy/use-energy-action';
import { useUserAccount } from '@/hooks/use-user-account';
import { freeAccessBannerDismissedAtom } from '@/state';

/** Tells a Free user with no AI Preview left what still works and how to get more AI. */
export const FreeAccessBanner = () => {
  const { account } = useUserAccount();
  const [dismissed, setDismissed] = useAtom(freeAccessBannerDismissedAtom);
  const { runEnergyAction, opening } = useEnergyAction();

  if (
    !account ||
    dismissed ||
    isPastDue(account.stripeSubscription) ||
    computeTier(account) !== 'free' ||
    hasCreditsLeft(account.aiPreviewQuota)
  ) {
    return null;
  }

  const action = getEnergyView(account)?.action;

  return (
    <Banner
      type="neutral"
      title="You’re using Free"
      message={
        'Keep working with manual notes, Blocks and existing content.' +
        (action === 'exploreTrial' ? ' Explore Trial for more AI.' : '')
      }
      onClose={() => setDismissed(true)}
      action={
        action ? { label: energyActionLabels[action], onClick: () => runEnergyAction(action), disabled: opening } : undefined
      }
    />
  );
};
